import { AgGridReact } from 'ag-grid-react';

/**
 * Default grid export for the export icon in the ComposedViewAgGrid.
 */
const exportGrid = (grid: AgGridReact) => grid.api.exportDataAsCsv();

export default exportGrid;
